import React, { useState, useEffect } from "react";
import { Table, Badge, Pagination } from "react-bootstrap";
import { useNavigate } from "react-router-dom"; // useNavigate import
import AdminSidebar from "../../../components/admin/sidebar/adminSidebar";
import axiosInstance from "../../../api/axios";

export default function AllUsers() {
  const [users, setUsers] = useState([]); // 사용자 데이터
  const [loading, setLoading] = useState(true); // 로딩 상태
  const [currentPage, setCurrentPage] = useState(1); // 현재 페이지
  const itemsPerPage = 10; // 한 페이지에 보여줄 항목 수
  const navigate = useNavigate(); // useNavigate 훅 사용

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await axiosInstance.get("/api/user/list"); // 모든 사용자 데이터를 불러오는 API 엔드포인트
        const usersData = Array.isArray(response.data)
          ? response.data
          : response.data.data; // 데이터 배열 추출
        setUsers(usersData);
      } catch (error) {
        console.error("Error fetching data:", error);
        setUsers([]); // 오류 시 빈 배열로 설정
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // 상태에 따른 뱃지 색상 및 텍스트 반환
  const getStatusBadge = (status) => {
    switch (status) {
      case "PENDING":
        return <Badge bg="warning">대기</Badge>;
      case "APPROVED":
        return <Badge bg="success">승인</Badge>;
      case "REJECTED":
        return <Badge bg="danger">반려</Badge>;
      default:
        return <Badge bg="secondary">알 수 없음</Badge>;
    }
  };

  // 날짜 포맷팅 함수
  const formatDate = (isoDate) => {
    const date = new Date(isoDate);
    return date.toLocaleString("ko-KR", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
  };

  // 현재 페이지에 보여줄 데이터 계산
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentUsers = users.slice(indexOfFirstItem, indexOfLastItem);

  // 페이지 변경 핸들러
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <AdminSidebar>
      <div className="all-users-page my-5">
        <h2 className="text-center mb-4">사용자 관리</h2>

        {loading ? (
          <p className="text-center">로딩 중...</p>
        ) : (
          <>
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>#</th>
                  <th>이름</th>
                  <th>이메일</th>
                  <th>회원 유형</th>
                  <th>상태</th>
                  <th>가입일</th>
                </tr>
              </thead>
              <tbody>
                {currentUsers.map((user, index) => (
                  <tr
                    key={user.userId}
                    onClick={() =>
                      navigate(`/admin/user/detail/${user.userId}`)
                    }
                    style={{ cursor: "pointer" }}
                  >
                    <td>{indexOfFirstItem + index + 1}</td>
                    <td>{user.nameKor}</td>
                    <td>{user.email}</td>
                    <td>{user.userType}</td>
                    <td>{getStatusBadge(user.status)}</td>
                    <td>{formatDate(user.createdAt)}</td>
                  </tr>
                ))}
              </tbody>
            </Table>

            {/* 페이지네이션 */}
            <Pagination className="justify-content-center mt-4">
              <Pagination.First
                onClick={() => handlePageChange(1)}
                disabled={currentPage === 1}
              />
              <Pagination.Prev
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
              />
              {Array.from(
                { length: Math.ceil(users.length / itemsPerPage) },
                (_, i) => (
                  <Pagination.Item
                    key={i + 1}
                    active={i + 1 === currentPage}
                    onClick={() => handlePageChange(i + 1)}
                  >
                    {i + 1}
                  </Pagination.Item>
                )
              )}
              <Pagination.Next
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={
                  currentPage === Math.ceil(users.length / itemsPerPage)
                }
              />
              <Pagination.Last
                onClick={() =>
                  handlePageChange(Math.ceil(users.length / itemsPerPage))
                }
                disabled={
                  currentPage === Math.ceil(users.length / itemsPerPage)
                }
              />
            </Pagination>
          </>
        )}
      </div>
    </AdminSidebar>
  );
}
